import React, { Component, Fragment, RefObject } from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { Transformer as HTMLTransformerElement } from 'konva/lib/shapes/Transformer'
import { RootState } from '../../store'
import { produce } from 'immer'
import Card from '../Card'
import Heading from '../Heading'
import LabelProperties from './LabelProperties'
import CloneLabelProperties from './CloneLabelProperties'
import ElementProperties from './ElementProperties/ElementProperties'
import ElementPicker from './ElementPicker'
import ImagePicker from './ImagePicker'
import Icon from '../Icon'
import { i18n } from '../../i18n/i18n'

interface Props {
    transformerRef: RefObject<HTMLTransformerElement>
}

type CombinedProps = Props & ConnectedProps<typeof connector>

interface State {
    isElementPickerCollapsed: boolean
    isImagePickerCollapsed: boolean
}

class Aside extends Component<CombinedProps, State> {
  state: State = {
    isElementPickerCollapsed: false,
    isImagePickerCollapsed: true
  }

  toggleElementPicker = () => {
    this.setState({ isElementPickerCollapsed: !this.state.isElementPickerCollapsed })
  }

  toggleImagePicker = () => {
    this.setState({ isImagePickerCollapsed: !this.state.isImagePickerCollapsed })
  }

  get labelAndElementProperties () {
    return !this.props.cloning && (
            <Fragment>
                <LabelProperties transformerRef={this.props.transformerRef}/>
                <ElementProperties/>

                {/* Element Picker Section */}
                <div className="mb-4 border border-solid border-primary">
                    <div
                        className="px-4 py-2 cursor-pointer flex items-center justify-between"
                        onClick={this.toggleElementPicker}>
                        <Heading
                            text={i18n('Elements')}
                            size="small"/>
                        <Icon
                            name={this.state.isElementPickerCollapsed ? 'chevron-down' : 'chevron-up'}
                            className={`w-5 h-5 ${this.state.isElementPickerCollapsed ? 'ri-arrow-down-s-line' : 'ri-arrow-up-s-line'}`}
                            size={'small'}
                            color={'gray'}
                        />
                    </div>
                    {!this.state.isElementPickerCollapsed && (
                        <div className="p-4 border-t border-solid overflow-scroll h-[136px]">
                            <ElementPicker/>
                        </div>
                    )}
                </div>

                {/* Image Picker Section */}
                <div className="mb-4 border border-solid border-primary">
                    <div
                        className="px-4 py-2 cursor-pointer flex items-center justify-between "
                        onClick={this.toggleImagePicker}>
                        <Heading
                            text={i18n('Uploads')}
                            size="small"/>
                        <Icon
                            name={this.state.isImagePickerCollapsed ? 'skip-up-line' : 'chevron-up'}
                            className={`w-5 h-5 ${this.state.isImagePickerCollapsed ? 'ri-arrow-down-s-line' : 'ri-arrow-up-s-line'}`}
                            size={'small'}
                            color={'gray'}
                        />
                    </div>
                    {!this.state.isImagePickerCollapsed && (
                        <div className="p-4 border-t border-solid ">
                            <ImagePicker/>
                        </div>
                    )}
                </div>

            </Fragment>
    )
  }

  get cloneLabelProperties () {
    return this.props.cloning && <CloneLabelProperties/>
  }

  render () {
    return (
            <Card
                background="white"
                flat={true}
                className="h-fit min-h-full">
                {this.labelAndElementProperties}
                {this.cloneLabelProperties}
            </Card>
    )
  }
}

function mapStateToProps (state: RootState, props: Props) {
  const { labelBuilder } = produce(state, draft => draft)
  const { cloning } = labelBuilder
  return { cloning }
}

const mapDispatchToProps = {}

const connector = connect(mapStateToProps, mapDispatchToProps)
export default connector(Aside)
